// js
import 'es6-shim';
import 'foundation-sites';
import 'angular';
import 'datatables.net-zf';
import 'angular-datatables';
import 'angular-route';
import 'checklist-model';
import 'angular-selectize2/dist/angular-selectize';

import routes from './routes';

import AppService from './services/app.service';
import DateRangeService from './services/daterange.service';
import DatePickerService from './services/datepicker.service';
import DataTableService from './services/datatable.service';
import ChartService from './services/chart.service';

import AppController from './controllers/app.controller';

import PaxReportController from './controllers/pax.report.controller';
import GroupPaxReportController from './controllers/group-pax.report.controller';
import FitPaxReportController from './controllers/fit-pax.report.controller';
import GroupsReportController from './controllers/groups.report.controller';
import InternationalReportController from './controllers/international.report.controller';
import DomesticReportController from './controllers/domestic.report.controller';
import DayTripperReportController from './controllers/day-tripper.report.controller';
import StateReportController from './controllers/state.report.controller';
import CountryReportController from './controllers/country.report.controller';
import AccommodationReportController from './controllers/accommodation.report.controller';
import TransportReportController from './controllers/transport.report.controller';
import AirlineReportController from './controllers/airline.report.controller';
import ReferralReportController from './controllers/referral.report.controller';
import OrganisationGroupsReportController from './controllers/organisation-groups.report.controller';
import OrganisationPaxReportController from './controllers/organisation-pax.report.controller';

import SnapshotReportController from './controllers/snapshot.report.controller';
import CustomReportController from './controllers/custom.report.controller';
import AdminController from './controllers/admin.controller';
import SettingController from './controllers/setting.controller';

import RecordController from './controllers/records/record.controller';
import CreateController from './controllers/records/create.controller';
import EditController from './controllers/records/edit.controller';
import SelectizeController from './controllers/records/selectize.controller';

import baseTableTemplate from './../../views/html/base-table.html';
import overviewBaseTableTemplate from './../../views/html/overview-base-table.html';
import compareTableTemplate from './../../views/html/compare-table.html';
import overviewCompareTableTemplate from './../../views/html/overview-compare-table.html';
import controlsTemplate from './../../views/html/controls.html';

// css
import './../scss/main.scss';

angular.module('HBTR', ['ngRoute', 'checklist-model', 'datatables', 'selectize']);
angular.module('HBTR').config(routes);

angular.module('HBTR').service('AppService', AppService);
angular.module('HBTR').service('DateRangeService', DateRangeService);
angular.module('HBTR').service('DatePickerService', DatePickerService);
angular.module('HBTR').service('DataTableService', DataTableService);
angular.module('HBTR').service('ChartService', ChartService);

angular.module('HBTR').controller('AppController', AppController);

angular.module('HBTR').controller('PaxReportController', PaxReportController);
angular.module('HBTR').controller('GroupPaxReportController', GroupPaxReportController);
angular.module('HBTR').controller('FitPaxReportController', FitPaxReportController);
angular.module('HBTR').controller('GroupsReportController', GroupsReportController);
angular.module('HBTR').controller('InternationalReportController', InternationalReportController);
angular.module('HBTR').controller('DomesticReportController', DomesticReportController);
angular.module('HBTR').controller('DayTripperReportController', DayTripperReportController);
angular.module('HBTR').controller('StateReportController', StateReportController);
angular.module('HBTR').controller('CountryReportController', CountryReportController);
angular.module('HBTR').controller('AccommodationReportController', AccommodationReportController);
angular.module('HBTR').controller('TransportReportController', TransportReportController);
angular.module('HBTR').controller('AirlineReportController', AirlineReportController);
angular.module('HBTR').controller('ReferralReportController', ReferralReportController);
angular.module('HBTR').controller('OrganisationGroupsReportController', OrganisationGroupsReportController);
angular.module('HBTR').controller('OrganisationPaxReportController', OrganisationPaxReportController);

angular.module('HBTR').controller('SnapshotReportController', SnapshotReportController);
angular.module('HBTR').controller('CustomReportController', CustomReportController);
angular.module('HBTR').controller('AdminController', AdminController);
angular.module('HBTR').controller('SettingController', SettingController);

// Record administration
angular.module('HBTR').controller('RecordController', RecordController);
angular.module('HBTR').controller('CreateController', CreateController);
angular.module('HBTR').controller('EditController', EditController);
angular.module('HBTR').controller('SelectizeController', SelectizeController);

angular.module('HBTR').run(($templateCache) => {
	$templateCache.put('base-table.html', baseTableTemplate);
	$templateCache.put('overview-base-table.html', overviewBaseTableTemplate);
	$templateCache.put('compare-table.html', compareTableTemplate);
	$templateCache.put('overview-compare-table.html', overviewCompareTableTemplate);
	$templateCache.put('controls.html', controlsTemplate);
});

$(function () {
	$(document).foundation();
});



/** WEBPACK FOOTER **
 ** ./resources/assets/js/main.js
 **/